import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";

export const callDataStart = () => {
	return {
		type: actionTypes.CALL_INFO_START,
	};
};

export const callDataFail = (error) => {
	return {
		type: actionTypes.CALL_INFO_FAIL,
		error: error,
	};
};

export const callDataSuccess = (posts, dispositions, agentBreaks) => {
	return {
		type: actionTypes.CALL_INFO_SUCCESS,
		posts: posts,
		dispositions: dispositions,
		agentBreaks: agentBreaks,
		
	};
};

export const callDataUpdate = (posts, dispositions, agentBreaks) => {
	return {
		type: actionTypes.CALL_INFO_UPDATE,
		posts: posts,
		dispositions: dispositions,
		agentBreaks: agentBreaks,
	};
};

export const callData = (agentId, startDate, endDate) => {
	return (dispatch) => {
		// console.log(agentId,startDate, endDate)
		dispatch(callDataStart());
		ctiRequest["CTI_AGENT_CALL_INFO"].agent_id = agentId;
		ctiRequest["CTI_AGENT_CALL_INFO"].start_date = startDate;
		ctiRequest["CTI_AGENT_CALL_INFO"].end_date = endDate;
		window.clientIP = localStorage.getItem("clientIP") ? localStorage.getItem("clientIP") : "127.0.0.1";
		ctiRequest["CTI_AGENT_CALL_INFO"].ip = window.clientIP;
		axios
			.post("/", ctiRequest["CTI_AGENT_CALL_INFO"])
			.then((result) => {
				if (result.data.response.status === "SUCCESS") {
					// console.log(result.data)
					dispatch(callDataSuccess(result.data.response.agent_data, result.data.response.disp_data, result.data.response.break_data));
				} else {
					dispatch(callDataFail(result.data.response.reason));
					//console.log(result.data.response.reason);
				}
			})
			.catch((err) => {
				console.log(err);
				dispatch(callDataFail(err));
			});
	};
};
